import Home from "./components/Home.vue";
import Selectcontainers from "./components/SelectContainers.vue";
import Predelivery from "./components/Predelivery.vue";
import CartReview from "./components/CartReview.vue";
import Quotes from "./components/Quotes.vue";

export const routes = [
    { path: '/', component: Home },
    { path: '/rentals', component: Selectcontainers },
    { path: '/rentals/cart/predeliveryQnA', component: Predelivery },
    { path: '/rentals/cart', component: CartReview },
    { path: '/quote', component: Quotes },
    { path: '*', redirect: '/' }
]